import { isMongoId, withPaginationParams } from '../../helpers';
import { z } from 'zod';
import { ListLpFeesCategory } from 'further-types/lp/lp-fee';
import { FundingSource } from 'further-types/lp/investment';
import { TransactionOperation } from 'further-types/lp/transaction';

export const ListFeesSchema = withPaginationParams(
  z.object({
    feesCategory: z.nativeEnum(ListLpFeesCategory),
  }),
  ['accrualDate'],
);

export const ApproveFeeSchema = z.object({
  vehicleId: z.string(),
  insideCommitment: z.object({
    transactions: z.array(
      z.object({
        transactionTypeId: z.string().refine(isMongoId()),
        operationType: z.nativeEnum(TransactionOperation),
      }),
    ),
    lpFees: z.array(
      z.object({
        _id: z.string(),
        feeExTaxLcy: z.number(),
        salesTaxAmountLcy: z.number(),
        fundingSource: z.nativeEnum(FundingSource),
      }),
    ),
  }),
  outsideCommitment: z.object({
    transactions: z.array(
      z.object({
        transactionTypeId: z.string().refine(isMongoId()),
        operationType: z.nativeEnum(TransactionOperation),
      }),
    ),
    lpFees: z.array(
      z.object({
        _id: z.string(),
        feeExTaxLcy: z.number(),
        salesTaxAmountLcy: z.number(),
        fundingSource: z.nativeEnum(FundingSource),
      }),
    ),
  }),
});
